import(/* webpackMode: "eager" */ "/usr/src/app/frontend/src/app/(editor)/page.tsx");
